import { render, staticRenderFns } from "./Modifier.vue?vue&type=template&id=54e4b350&scoped=true&"
import script from "./Modifier.vue?vue&type=script&lang=js&"
export * from "./Modifier.vue?vue&type=script&lang=js&"
import style0 from "./Modifier.vue?vue&type=style&index=0&id=54e4b350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e4b350",
  null
  
)

export default component.exports